import { useState } from 'react';
import './PasswordInput.scss';
import { Reveal, Hide } from '../../../constants/Icons';

interface IPasswordInputProps {
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
  id: string;
  value?: string;
  testId?: string;
  inputClassName?: string;
  labelClassName?: string;
  helperText?: string;
  ariaLabel?: string;
  labelText?: string;
}

export function PasswordInput({
  onChange,
  value,
  id,
  testId,
  inputClassName,
  labelClassName,
  helperText,
  ariaLabel,
  labelText
}: IPasswordInputProps) {
  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <>
      <input
        aria-label={ariaLabel}
        data-testid={testId}
        id={id}
        type={passwordVisible ? 'text' : 'password'}
        className={inputClassName}
        onChange={onChange}
        value={value ?? undefined}
      />
      <span
        className="password-icon"
        data-testid="password-icon"
        onClick={() => setPasswordVisible(!passwordVisible)}
      >
        {passwordVisible ? Hide : Reveal}
      </span>
      <label htmlFor={id} className={labelClassName}>
        {labelText ? labelText : "Password"}
      </label>
      <span className="helper-text login-field-error" data-error={helperText} />
    </>
  );
}
